<template>
    <section id="portfolio-section">
      <div class="container">
        <div class="title-section">
          <h1>{{data.title}}</h1>
          <span></span>
          <p>{{data.subtitle}}</p>
        </div>

        <div class="row">
          <div class="col-md-4" v-for="(item, index) in data.categories">
                        <div class="accordion-box third-style">
              <div :id="'accordion'+index">
                <div class="card">
                  <div class="card-header" :id="'headingOneb'+index">
                    <h5 class="mb-0">
                      <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapseOneb'+index" aria-expanded="false" :aria-controls="'collapseOneb'+index">
                        <span></span>
                      {{item.title}}
                      </button>
                    </h5>
                  </div>

                  <div :id="'collapseOneb'+index" class="collapse" :aria-labelledby="'headingOneb'+index" :data-parent="'#accordion'+index">
                    <div class="card-body">
                      <ul class="unorder-list unorder-first-style">
                <li v-for="item2 in item.products" ><i class="fa fa-angle-right"></i>{{item2.name}}</li>
              </ul>
                    </div>
                  </div>
                </div>
               
        </div>
  
      </div>
    </div>

  </div>

  <div class="call-to-action style-2">
          <a :href="data.products_file" download class="default-button">{{data.products_buttom}}</a>
          <div class="action-content">
            <h2>{{data.products_title}}</h2>
          </div>
        </div>
</div>
    </section>
</template>

<script>
export default {
  name: 'Portafolio',
  props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
